import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import styled from 'styled-components';

const Wrapper = styled.section`
  position: relative;
`;

const Container = styled.div<{ desktopImage: string; mobileImage: string }>`
  min-height: 525px;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-image: url(${({ desktopImage }) => desktopImage});
  position: relative;

  @media ${until(Device.Tablet)} {
    padding-bottom: 50px;
  }

  @media ${until(Device.TabletLarge)} {
    background-image: url(${({ mobileImage, desktopImage }) => (mobileImage !== '' ? mobileImage : desktopImage)});
  }
`;

const ContentContainer = styled.div`
  padding: 40px 100px;
  max-width: 900px;

  @media ${until(Device.TabletLarge)} {
    padding: 40px 50px;
  }

  @media ${until(Device.Tablet)} {
    padding: 30px 20px;
  }
`;

const Title = styled.h1`
  ${fonts.helvetica['93-black-extended']};
  color: ${brand.white};
  text-transform: uppercase;
  font-style: italic !important;
  font-size: 56px;
  margin-bottom: 70px;

  span {
    color: ${brand.red.base};
    display: block;
  }

  @media ${until(Device.TabletLarge)} {
    max-width: 100%;
    font-size: 42px;
    margin-bottom: 50px;
  }

  @media ${until(Device.Tablet)} {
    font-size: 32px;
  }

  @media ${until(Device.MobileLarge)} {
    font-size: 28px;
  }
`;

const Subtitle = styled.h2`
  ${fonts.helvetica['93-black-extended']};
  color: ${brand.white};
  text-transform: uppercase;
  font-style: italic;
  font-size: 56px;
  margin-bottom: 0px;

  span {
    color: ${brand.red.base};
  }

  @media ${until(Device.TabletLarge)} {
    font-size: 42px;
  }

  @media ${until(Device.Tablet)} {
    font-size: 32px;
  }

  @media ${until(Device.MobileLarge)} {
    font-size: 28px;
  }
`;

const SupportingText = styled.div``;

const FooterLogoContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
`;

const FooterLogo = styled.img`
  margin: 15px;
`;

const Footer = styled.div`
  min-height: 165px;
  background-color: ${brand.black};
  padding: 40px 100px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media ${until(Device.TabletLarge)} {
    flex-direction: column;
    padding: 40px 50px;
  }

  @media ${until(Device.Tablet)} {
    padding: 30px 20px;
  }
`;

const FooterBlock = styled.div`
  width: 28%;

  @media ${until(Device.TabletLarge)} {
    width: 100%;
    margin-bottom: 15px;
    text-align: center;
  }
`;

const FooterImage = styled.img`
  max-height: 140px;
`;

const FooterContent = styled.div`
  color: ${brand.white};
`;

const FooterButtonBlock = styled.div`
  width: 28%;
  text-align: center;

  @media ${until(Device.TabletLarge)} {
    width: 100%;
    margin-bottom: 15px;
    text-align: center;
  }
`;

export const WhatsNewBannerStyles = {
  Wrapper,
  Container,
  ContentContainer,
  Title,
  Subtitle,
  SupportingText,
  FooterLogoContainer,
  FooterLogo,
  Footer,
  FooterBlock,
  FooterImage,
  FooterContent,
  FooterButtonBlock,
};
